import { SelectOptions } from '../components/GenericFormField';

/**
 * Converts an enum or array of strings to an array of SelectOptions.
 * @param input - The enum or string array to convert.
 * @returns An array of SelectOptions.
 */
export function toSelectOptions(input: object | string[]): SelectOptions[] {
  // Check if input is an object (e.g., enum) and not an array
  if (typeof input === 'object' && !Array.isArray(input)) {
    return Object.values(input).map((value) => ({
      label: value,
      value,
    }));
  }

  // Handle case when input is an array of strings
  if (Array.isArray(input)) {
    return input.map((value) => ({
      label: value,
      value,
    }));
  }

  return []; // Return an empty array if neither condition is met
}
